import { TransportationType } from "../../../interface/transportation";
import { MainContentsItem } from "../../molcules/MainContentItem";
import * as S from "./mainContentList.styles";

interface MainContentListProps {
  contentTit: string;
  transportations: TransportationType[];
  isLoading: boolean;
  moveToMatchlist: () => void;
  moveToMatchListDetail: () => void;
  handleCancelRequest: () => void;
}

export const MainContentsList = ({
  contentTit,
  transportations,
  isLoading,
  moveToMatchlist,
  moveToMatchListDetail,
  handleCancelRequest,
}: MainContentListProps) => {
  return (
    <S.MainContentsSection>
      <S.MainContentsListTit>{contentTit}</S.MainContentsListTit>
      <S.MainContentsList>
        <MainContentsItem
          transportations={transportations}
          contentTit={contentTit}
          isLoading={isLoading}
          moveToMatchlist={moveToMatchlist}
          moveToMatchListDetail={moveToMatchListDetail}
          handleCancelRequest={handleCancelRequest}
        />
      </S.MainContentsList>
    </S.MainContentsSection>
  );
};
